<template>
  <DatatableReportV3
    id="admins-table"
    ref="admins_table"
    class="p-2"
    title="Admin Users"
    :config="config"
    :source="props.source"
    :filters="props.filters"
    no-download
  >
    <template #actions>
      <SeraButton
        icon="fa fa-plus fa-fw"
        text="Add Admin"
        @click="handleClickAddAdmin"
      />
    </template>
  </DatatableReportV3>
</template>

<script setup lang="ts">
import SeraButton from "@/components/Button.vue";
import { adminCreatePath } from "@/mixins/path_helpers.js";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

// Define props
const props = defineProps({
  source: {
    type: String,
    default: ""
  },
  filters: {
    type: Array,
    default: () => []
  }
});

// Define static config object
const config = {
  responsive: true,
  pageLength: 25,
  order: [[0, "asc"]],
  columns: [
    { data: "name", responsivePriority: 1, className: "wrap-when-responsive" },
    { data: "email", responsivePriority: 2 },
    {
      data: "role",
      title: "Access Level",
      filterName: "role",
      responsivePriority: 3
    },
    {
      data: "receives_emails",
      title: "Receives Email?",
      filterName: "receives_emails",
      responsivePriority: 4
    }
  ]
};

// Define action handlers
const handleClickAddAdmin = () => {
  window.location.href = adminCreatePath();
};
</script>
